import { type CSSProperties } from "react"

type BrainSideIconProps = {
  size?: number
  strokeWidth?: number
  style?: CSSProperties
}

// Hand-authored side-profile brain (no equivalent in any major icon set
// surveyed). Cerebrum at top-left with two horizontal gyri squiggles, a
// pronounced cerebellum bulge at the back-right, and a short brainstem stub
// at the bottom. Stroke-only on a 24x24 viewBox so it sits visually with the
// neighbouring lucide icons in the labor-mix segments.
export const BrainSideIcon = ({
  size = 24,
  strokeWidth = 1.75,
  style,
}: BrainSideIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
    aria-hidden
  >
    <path d="M5 7 C 5 4, 9 3, 12 3 C 16 3, 19 5, 19 8 C 19 10, 19 11, 18 12 C 22 12, 23 17, 19 18 C 18 19, 17 19, 16 18 L 14 18 L 14 22 L 11 22 L 11 18 L 8 18 C 4 18, 2 14, 4 11 C 3 9, 3 7, 5 7 Z" />
    <path d="M6 9 Q 9 11, 12 10 T 17 10" />
    <path d="M5 13 Q 8 14, 11 13.5 T 16 13.5" />
  </svg>
)
